<div class="animated fadeIn backend form-page">
    <div class="row">
        <form id="customerForm" appPromptUnsubmitted (ngSubmit)="save()">
            <div class="row">
                <div class="col-12">
                    <div class="top-header-area">
                        <div class="header-area">
                            <h3>User details</h3>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="row">
                        <div class="form-group col-lg-6 col-sm-6">
                            <label for="firstName">Firstname</label>
                            <input class="form-control" id="firstName" type="text" [(ngModel)]="user.firstName"
                                name="firstName" [appIsInvalid]="!user.firstName">
                            <div class="invalid-feedback">
                                Firstname is Required.
                            </div>
                        </div>
                        <div class="form-group col-lg-6 col-sm-6">
                            <label for="lastName">Lastname</label>
                            <input class="form-control" id="lastName" type="text" [(ngModel)]="user.lastName"
                                name="lastName" [appIsInvalid]="!user.lastName">
                            <div class="invalid-feedback">
                                Lastname is Required.
                            </div>
                        </div>
                        <div class="form-group col-lg-6 col-sm-6">
                            <label for="username">Username</label>
                            <input class="form-control" id="username" type="text" [(ngModel)]="user.username"
                                name="username" [appIsInvalid]="!user.username">
                            <div class="invalid-feedback">
                                Username is Required.
                            </div>
                        </div>
                        <div class="form-group col-lg-6 col-sm-6">
                            <label for="password">Password</label>
                            <input class="form-control" id="password" type="password" [(ngModel)]="user.password"
                                name="password" [appIsInvalid]="!user.id ? !user.password: ''">
                            <div class="invalid-feedback">
                                Password is Required.
                            </div>
                        </div>
                        <div class="form-group col-lg-6 col-sm-6">
                            <label for="role">Role</label>
                            <select class="form-control custom-select" [(ngModel)]="user.userRole" name="role">
                                <option *ngFor="let userRole of userRoles" [value]="userRole.value">
                                    {{userRole.description}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="save-button-area">
                        <button type="submit" class="btn btn-primary">Save</button>
                        <button type="button" class="btn btn-outline-dark"
                            [routerLink]="['/admin/users']">Cancel</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>